import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/Button'
import FormCollection from 'components/Form/Collection'
import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import classes from './NewUser.scss'

import { makeOptions, rolloverOptions } from 'helpers/components'
import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const NewUser = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Adding a New User
      </div>
    </header>

    <fieldset>
      <Input label='Email' type='email' placeholder='email address' {...props.fields.email} />
      <Input label='Password' placeholder='password' type='password' {...props.fields.password} />

      {/*
        No timezones for now..  timezoneOptions comes from helpers/components
        <Select
          label='Timezone'
          placeholder='select timezone'
          selectOptions={timezoneOptions}
          clearable={false}
          {...props.fields.timezone}
        />
      */}

      <Checkbox label='Is Administrator?' {...props.fields.is_admin} />
      <Checkbox label='Allow User to Request Offlist Item' {...props.fields.can_special_order} />
      <Checkbox
        subLabel='They will still get an email if the customer field Order Confirmation Emails includes them.'
        label='Send Order Confirmation Emails'
        {...props.fields.send_order_confirmations}
      />

      <Select
        label='Rollover to Next Day'
        note='After this time, the customer would default to ordering for the next day.'
        placeholder='select a time'
        selectOptions={rolloverOptions}
        clearable={false}
        {...props.fields.rollover_offset}
      />

      <FormCollection
        label='Customers'
        collection={props.fields.customers}
        defaultModel={{ id: undefined }}
        fields={[
          { name: 'id', element: 'select', selectOptions: makeOptions(props.customers), placeholder: 'add a customer' }
        ]}
        error={props.fields.email.value && props.error}
      />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Create User
      </Button>
    </footer>
  </form>
)

NewUser.propTypes = {
  user: PropTypes.object.isRequired,
  customers: PropTypes.array.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  error: PropTypes.any
}

export default NewUser



// WEBPACK FOOTER //
// ./src/components/Users/New/NewUser.js